import './styles/ShowLayers.css'
import Selector from './Selector'
import InfoStatus from './InfoStatus'
import Action from './Action'
import {fetchData} from '../hooks/fetchData'
import { useFetch } from '../hooks/useFetch'
import { Suspense, useEffect, useState } from 'react'
import mapboxgl from 'mapbox-gl';
import { capitalizeFirstLetter } from '../utils/utils'
import { lang } from './generales/traduction'

const ShowRelationDemo =(props)=>{
    const closeFindHost=()=>{
           const popups = document.querySelectorAll('.custom-popup-findHost'); 
           popups.forEach(popup => {
       //    console.log(popups)
         popup.remove();
         });
       
       }

    const handledeleteRelation=(index)=>{
        // setHostSelected((prevRows) => {
        //       // Busca si el hostid ya existe en el array de objetos
        //       const exists = prevRows.some(item => item.hostid === elemento.hostid);

        //       // Si existe, filtra para eliminar el objeto, si no existe, lo agrega
        //       if (exists) {
        //         return prevRows.filter(item => item.hostid !== elemento.hostid);
        //       } else {
        //         return [...prevRows, elemento];
        //       }
        //     });
        const nuevaLista = props.demoRelaciones.filter((_, i) => i !== index);
        props.setDemoRelaciones(nuevaLista);
    }
    return(
        <>
        <div className='contShowLayers' style={{right:'3%'}}>
                <div className="container-ShowLayers">
                    <input checked={false}  readOnly className="checkbox-ShowLayers"  style={{height:'30px'}} type="checkbox" onClick={closeFindHost}/> 
                  
                    <div className="mainbox-ShowLayers" style={{minWidth:'100px'}}>
                        <div className='txtTitle--ShowLayers' style={{height:'30px'}}>
                        {/* <input defaultChecked className="checkbox-ShowLayers" type="checkbox" onClick={closeFindHost}/>  */}
                        {'Correlaciones'}
                       </div>
                       <div className='container-ShowLayers-list'>
                            {/* <div className='compact-ShowLayers-list'> */}
                            <div id="compact-ShowLayers-list" style={{minWidth:'100px',gridTemplateColumns:'unset'}}>
                            {
                                props.demoRelaciones.length === 0 ? <p>Sin Relaciones</p> : (
                                    <>
                                    {props.demoRelaciones.map((element, index) => (
                                        <div style={{display:'flex'}}>

                                        {/* <input defaultChecked={element.show}  value={index} name="r" type="checkbox" id={`checkbox-${index + 1}`} onClick={()=>{handleClick(element,index);if(element.name=='Excepciones'){showExecptions()}}} /> */}
                                        <div style={{paddingLeft:'5px'}}>
                                            <img
                    src={
                      "/iconos/close.png"
                    } 
                    onClick={()=>handledeleteRelation(index)}
                    name="Eliminar"  title='Eliminar' className="btnAction delteException" style={{width:'45%'}}
                  />
                                        </div>
                                        <div >
                                        <label>{element.properties.host_padre+' - '+element.properties.host_hijo}</label>

                                        </div>
                                        
                                        </div>
                                    ))}
                                    </>
                                )
                                }
                               
                                
                            </div>
                               
               
            </div>
                    </div>
                    
            </div>
            
        </div>
        </>
    )
}

export default ShowRelationDemo